import { render, staticRenderFns } from "./PushFulfillments.vue?vue&type=template&id=71e37d29&"
import script from "./PushFulfillments.vue?vue&type=script&lang=js&"
export * from "./PushFulfillments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports